export const CUSTOMER_SERVICE_OPEN_EVENT = "customer-service:open";

export const openCustomerService = () => {
  if (typeof window === "undefined") {
    return;
  }

  let event;
  if (typeof window.CustomEvent === "function") {
    event = new CustomEvent(CUSTOMER_SERVICE_OPEN_EVENT);
  } else {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(CUSTOMER_SERVICE_OPEN_EVENT, false, false, null);
  }
  window.dispatchEvent(event);
};
